import React, { useState, useEffect } from 'react';
import Modal from '../../../../../../common/Modal';

const EditLessonModal = ({ isOpen, onClose, onSubmit, lesson, sectionId }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('video_url');
  const [contentUrl, setContentUrl] = useState('');
  const [contentText, setContentText] = useState('');
  const [file, setFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [duration, setDuration] = useState('');
  const [isFree, setIsFree] = useState(false); // القيمة الافتراضية هي غير مجاني (مدفوع)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [hasFileChanged, setHasFileChanged] = useState(false);

  // تعيين البيانات الأولية عند فتح النافذة
  useEffect(() => {
    if (isOpen && lesson) {
      // تحميل بيانات الدرس
      setTitle(lesson.title || '');
      setDescription(lesson.description || '');
      
      // استخدام lesson_type بدلاً من type إذا كان متوفراً
      const lessonType = lesson.lesson_type || lesson.type || 'video_url';
      // تعيين نوع الدرس
      setType(lessonType);
      
      // معالجة محتوى الدرس بناء على النوع
      if (lessonType === 'video_url' || lessonType === 'video_file') {
        // تعيين رابط الفيديو
        setContentUrl(lesson.content_url || '');
      } else if (lessonType === 'text') {
        // تعيين محتوى النص
        setContentText(lesson.content_text || '');
      } else if (lessonType === 'file') {
        // تعيين رابط الملف
        setContentUrl(lesson.content_url || '');
      } else if (lessonType === 'video_embed') {
        // تعيين كود التضمين
        setContentUrl(lesson.content_url || '');
      }
      
      // تعيين المدة
      setDuration(lesson.duration || '');
      
      // تعيين حالة المجاني - التعامل مع جميع أنواع القيم المحتملة (0/1، true/false، null/undefined)
      // تعيين حالة الدرس المجاني
      const isFreeValue = lesson.is_free === true || lesson.is_free === 1 || lesson.is_free === '1';
      // تحويل حالة الدرس المجاني
      setIsFree(isFreeValue);
      
      // إعادة تعيين حالة الملفات
      setFile(null);
      setVideoFile(null);
      setHasFileChanged(false);
      
      // إعادة تعيين الخطأ
      setError('');
    } else {
      // إعادة تعيين الحالة عندما يكون lesson غير موجود
      setTitle('');
      setDescription('');
      setType('video_url');
      setContentUrl('');
      setContentText('');
      setDuration('');
      setIsFree(false);
      setFile(null);
      setVideoFile(null);
      setHasFileChanged(false);
      setError('');
    }
  }, [isOpen, lesson]);

  // إغلاق النافذة
  const handleClose = () => {
    onClose();
  };

  // تقديم النموذج
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // التحقق من البيانات
    if (!title.trim()) {
      setError('يرجى إدخال عنوان الدرس');
      return;
    }
    
    if (type === 'video_url' && !contentUrl.trim()) {
      setError('يرجى إدخال رابط الفيديو');
      return;
    }
    
    if (type === 'video_file' && !videoFile && !lesson?.content_url) {
      setError('يرجى اختيار ملف فيديو');
      return;
    }
    
    if (type === 'text' && !contentText.trim()) {
      setError('يرجى إدخال محتوى الدرس');
      return;
    }
    
    if (type === 'file' && !file && !lesson?.content_url) {
      setError('يرجى اختيار ملف');
      return;
    }
    
    try {
      setLoading(true);
      
      // تجهيز بيانات الدرس
      
      // تحويل نوع الدرس من الواجهة إلى النوع المتوافق مع الباك إند
      // إرسال نوع الدرس الأصلي بدون تحويل
      // نوع الدرس المرسل للسيرفر
      
      const lessonData = {
        title,
        description,
        // استخدام النوع الأصلي مباشرة
        type: type,
        duration: (type === 'video_url' || type === 'video_file' || type === 'video_embed') ? (duration || '0') : '0',
        is_free: isFree
      };
      
      // إضافة المحتوى حسب النوع الأصلي
      if (type === 'video_url') {
        lessonData.content_url = contentUrl;
      } else if (type === 'video_embed') {
        // إرسال كود الإمبد في content_url ليتحدث في الباك إند
        lessonData.content_url = contentUrl;
      } else if (type === 'video_file' && hasFileChanged) {
        lessonData.video_file = videoFile;
      } else if (type === 'text') {
        lessonData.content_text = contentText;
      } else if (type === 'file' && hasFileChanged) {
        lessonData.file = file;
      }
      
      // إضافة معرف الدرس الحالي
      if (lesson?.id) {
        lessonData.id = lesson.id;
      }
      
      // إضافة رابط المحتوى الحالي إذا كان موجوداً ولم يتم تغييره
      if ((type === 'video_file' || type === 'file') && !hasFileChanged && lesson?.content_url) {
        lessonData.content_url = lesson.content_url;
      }
      
      // إرسال بيانات الدرس
      
      // إرسال البيانات
      await onSubmit(lessonData);
      
      // إغلاق النافذة بعد التعديل
      handleClose();
    } catch (err) {
      // معالجة خطأ تحديث الدرس
      setError('حدث خطأ أثناء تعديل الدرس. يرجى المحاولة مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  // تغيير الملف
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setHasFileChanged(true);
    }
  };

  // تغيير ملف الفيديو
  const handleVideoFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setVideoFile(e.target.files[0]);
      setHasFileChanged(true);
    }
  };

  // منع تغيير قيمة المدة عند استخدام عجلة الماوس
  const handleWheel = (e) => {
    e.target.blur();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="تعديل درس"
      size="lg"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* عنوان الدرس */}
        <div>
          <label htmlFor="title" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            عنوان الدرس <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
            placeholder="أدخل عنوان الدرس"
          />
        </div>

        {/* وصف الدرس */}
        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            وصف الدرس
          </label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
            placeholder="أدخل وصف الدرس (اختياري)"
          />
        </div>

        {/* نوع الدرس */}
        <div>
          <label htmlFor="type" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            نوع الدرس <span className="text-red-500">*</span>
          </label>
          <select
            id="type"
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
          >
            <option value="video_url">فيديو من رابط</option>
            <option value="video_embed">رابط امبد</option>
            <option value="video_file">فيديو من ملف</option>
            <option value="text">نص</option>
          </select>
        </div>

        {/* محتوى الدرس حسب النوع */}
        {type === 'video_url' && (
          <div>
            <label htmlFor="content_url" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              رابط الفيديو <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="content_url"
              value={contentUrl}
              onChange={(e) => setContentUrl(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
              placeholder="أدخل رابط الفيديو"
            />
          </div>
        )}

        {type === 'video_embed' && (
          <div>
            <label htmlFor="content_url" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              كود الإمبد <span className="text-red-500">*</span>
            </label>
            <textarea
              id="content_url"
              value={contentUrl}
              onChange={(e) => setContentUrl(e.target.value)}
              rows={5}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
              placeholder='أدخل كود الإمبد (مثال: <iframe src="https://www.example.com/embed" ...></iframe>)'
            />
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              أدخل كود الإمبد كاملاً بما في ذلك وسوم iframe
            </p>
          </div>
        )}

        {type === 'video_file' && (
          <div>
            <label htmlFor="video_file" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              ملف الفيديو <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              id="video_file"
              onChange={handleVideoFileChange}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
              accept=".mp4,.webm,.mov,.avi"
            />
            {lesson?.content_url && !hasFileChanged && (
              <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                الفيديو الحالي: <a href={lesson.content_url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{lesson.content_url.split('/').pop()}</a>
              </div>
            )}
            {videoFile && (
              <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                الفيديو الجديد: {videoFile.name}
              </div>
            )}
          </div>
        )}

        {type === 'text' && (
          <div>
            <label htmlFor="content_text" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              محتوى الدرس <span className="text-red-500">*</span>
            </label>
            <textarea
              id="content_text"
              value={contentText}
              onChange={(e) => setContentText(e.target.value)}
              rows={5}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
              placeholder="أدخل محتوى الدرس"
            />
          </div>
        )}

        {type === 'file' && (
          <div>
            <label htmlFor="file" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              الملف {!lesson?.content_url && <span className="text-red-500">*</span>}
            </label>
            <input
              type="file"
              id="file"
              onChange={handleFileChange}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
              accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip,.rar"
            />
            {lesson?.content_url && !hasFileChanged && (
              <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                الملف الحالي: <a href={lesson.content_url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{lesson.content_url.split('/').pop()}</a>
              </div>
            )}
            {file && (
              <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                الملف الجديد: {file.name}
              </div>
            )}
          </div>
        )}

        {/* خيار مجاني */}
        <div className="flex items-center justify-between border p-3 rounded-md bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700">
          <div className="flex flex-col">
            <label htmlFor="is_free" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              درس مجاني (معاينة)
            </label>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              إذا كان مفعلاً، سيتمكن المستخدمون من مشاهدة هذا الدرس بدون شراء الدورة
            </div>
          </div>
          <div className="relative inline-block w-12 h-6 transition duration-200 ease-in-out rounded-full cursor-pointer">
            <input
              type="checkbox"
              id="is_free"
              checked={isFree}
              onChange={(e) => setIsFree(e.target.checked)}
              className="absolute w-0 h-0 opacity-0"
            />
            <label
              htmlFor="is_free"
              className={`absolute left-0 right-0 block h-6 rounded-full transition-colors duration-200 ease-in cursor-pointer ${
                isFree ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600'
              }`}
            >
              <span
                className={`absolute left-0 bottom-0 top-0 block w-6 h-6 mt-0 mb-0 ml-0 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${
                  isFree ? 'translate-x-6' : 'translate-x-0'
                }`}
              />
            </label>
          </div>
        </div>

        {/* مدة الدرس (للفيديو والدروس المضمنة) */}
        {(type === 'video_url' || type === 'video_file' || type === 'video_embed') && (
          <div>
            <label htmlFor="duration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              مدة الدرس (بالدقائق)
            </label>
            <input
              type="number"
              id="duration"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              onWheel={handleWheel}
              min="0"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white"
              placeholder="أدخل مدة الدرس بالدقائق"
            />
          </div>
        )}

        {/* رسالة الخطأ */}
        {error && (
          <div className="text-red-500 text-sm">{error}</div>
        )}

        {/* أزرار الإجراءات */}
        <div className="flex justify-end gap-3 pt-3">
          <button
            type="button"
            onClick={handleClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none"
            disabled={loading}
          >
            إلغاء
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'جاري الحفظ...' : 'حفظ التغييرات'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EditLessonModal;
